import { expVal } from '@confluence/feature-experiments';
import { isSpaceOverview } from '@confluence/named-routes/entry-points/routes-utils.ts';

/**
 * Re-evaluates experiments in the browser when their initial evaluation cannot emit an exposure.
 */
export const fireSSRExperimentExposures = () => {
	expVal('move_statsig_bootstrap_after_fmp', 'isEnabled', false);
	expVal('confluence_media_token_preload_agg_query', 'isEnabled', false);
	expVal('confluence_react_streaming_all_routes', 'isEnabled', false);
	expVal('confluence_anon_react_streaming', 'isEnabled', false);

	if (isSpaceOverview()) {
		expVal('confluence_space_overview_react_streaming', 'isEnabled', false);
	}

	// The server reads this in addLoadableId for streamed pages, so only those pages are exposed.
	if (window.__SSR_REACT_STREAMING__) {
		expVal('confluence_ssr_streamed_loadable_preload', 'isEnabled', false);
	}
};
